/** Notebook cover gradient presets, shared by Library cards and the new-notebook dialog. */
export const COVERS = [
  'linear-gradient(135deg,#E8927C,#D9705A)',
  'linear-gradient(135deg,#8FB8A8,#6E9C8A)',
  'linear-gradient(135deg,#7FB0CC,#4A7A96)',
  'linear-gradient(135deg,#B08CB5,#7D5A82)',
  'linear-gradient(135deg,#E0AE58,#C98A2D)',
  'linear-gradient(135deg,#9AA6B4,#5C6672)',
];

export function coverStyle(i: number): string {
  return COVERS[i % COVERS.length]!;
}
